export const TDS_REPORT_REQUEST = 'TDS_REPORT_REQUEST';
export const TDS_REPORT_SUCCESS = 'TDS_REPORT_SUCCESS';
export const TDS_REPORT_FAILURE = 'TDS_REPORT_FAILURE';